import { z } from "zod";
import { schemes } from "../../schema-validation";
import { snapshotSchema } from "./snapshot";

export const employeeCheckSchema = z.object({
  paystub_id: schemes.uuid(),
  reportingPeriodID: schemes.mongoObjectId(),
});

export const employeeChecksSchema = z.object({
  employeeID: schemes.mongoObjectId(),
  checks: z.array(employeeCheckSchema),
});

export const employeeChecksAndSnapshotSchema = z.array(
  z.intersection(employeeCheckSchema, z.object({ snapshot: snapshotSchema }))
);

export const employeeChecksMapSchema = z.record(
  employeeChecksAndSnapshotSchema
);

export type EmployeeChecksAggregation = z.infer<typeof employeeChecksSchema>;
export type EmployeeChecksMap = z.infer<typeof employeeChecksMapSchema>;
